import React from 'react';
import axios from "axios";
import { useState, useEffect, useMemo } from 'react';
import MaterialReactTable from 'material-react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faPencil,  faTrashAlt } from '../../../node_modules/@fortawesome/free-solid-svg-icons/index';
import $ from 'jquery';


const Usertype = () => {
    const [usertypeData, setusertypeData] = useState([]);
    const [flag, setFlag] = useState(false);
    const [userTypeValue, setUserTypeValue] = useState("");
    const [deleteCode, setDeleteCode] = useState({});
    const [editCode, setEditCode] = useState("");
    let localUserTypeName = ""

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        const result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/usertype`);
        setusertypeData(result.data.dataContent);
    };

    useEffect(() => {
        if (flag === true) {
            fetchData()
        }
    }, [flag])

    const columns = useMemo(
        () => [
            {
                header: 'S.No',
                Cell: cell => Number(cell.row.id) + 1
            },
            {
                accessorKey: 'userTypeName',
                header: 'User Type Name',
            },
            {
                accessorKey: 'visibility',
                header: 'Visibility',
            },
             {
                accessor: '',
                header: 'Actions',
                Cell: cell => <>
                    <i className="btn text-primary" type="button" onClick={() => handleEditUserType(cell.row.original)}><FontAwesomeIcon icon={faPencil} /></i>
                    <i className="btn text-danger" type="button" data-bs-toggle="modal" data-bs-target="#myDelete" onClick={() => setDeleteCode({ "UserTypeCode": cell.row.original.userTypeCode })}> <FontAwesomeIcon icon={faTrashAlt} /></i></>

            },
        ],
        [],
    );

    function removed() {
        var mpopup = document.getElementById('mpopupBox');
        mpopup.style.display = "none";
        setUserTypeValue("")

    } 

    function removedAdd() {
        var mpopup = document.getElementById('addNewUserType');
        mpopup.style.display = "none";
        setUserTypeValue("")

    }

    function handleEditUserType(value) {
          document.getElementById("userTypeEdit").value = value.userTypeName;
        
        // localUserTypeName = value.userTypeName
        // document.getElementById("userTypeEdit").defaultValue= ""
        // document.getElementById("userTypeEdit").defaultValue = value.userTypeName;
        setEditCode({ "UserTypeCode": value.userTypeCode, "UserTypeName": value.userTypeName })
     //   setUserTypeValue(value.seasonName)
        var x = document.createElement("a")
        x.id = "mpopupLink";
        var mpopup = document.getElementById('mpopupBox');
        mpopup.style.display = "block";
    }

    function AddNewUserType() {
        if(userTypeValue) {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
    
            var raw = JSON.stringify({
                "UserTypeName": userTypeValue,
                "SortingOrder": 1,
                "CreatedByUC": localStorage.getItem("userCodeGlobal")
            });
    
            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: raw,
                redirect: 'follow'
            };
    
            fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/usertype`, requestOptions)
                .then(response => response.text())
                .then((result) => {
                    alert(JSON.parse(result).message);
                    //   $('#addNewBtn').on('click', function () {
                        // $('#addNewUserType').modal('hide');        
                        //  })
                    if (JSON.parse(result).success === true) {
                        // $('#addNewBtn').on('click', function () {
                            // $('#addNewUserType').modal('hide');        
                            // })
                        
                        setFlag(true);
                        setUserTypeValue("")
                        removedAdd()
    
                    }
    
                })
                .catch(error => console.log('error', error));
    

        } else {
            alert("Enter User Type Name")
        }
           }

    function deleteData(value) {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify(deleteCode);

        var requestOptions = {
            method: 'DELETE',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/usertype`, requestOptions)
            .then(response => response.text())
            .then(result => {
                if (JSON.parse(result).success === true) {
                    fetchData()

                }
            })
            .catch(error => console.log('error', error));
    }

    function EditUserType() {
       
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "UserTypeCode": editCode.UserTypeCode,
            "UserTypeName": userTypeValue,
            "SortingOrder": 1,
            "Visibility": "Y",
            "ModifiedByUC": localStorage.getItem("userCodeGlobal")
        });

        var requestOptions = {
            method: 'PUT',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/usertype`, requestOptions)
            .then(response => response.text())
            .then(result => {
                alert(JSON.parse(result).message)
                if (JSON.parse(result).success === true) {
                    setUserTypeValue("")
                    fetchData()
                    removed()


                }
            }
            )
            .catch(error => console.log('error', error));
           
    }

    function handleUserTypeValue(value) {
        const valueFinal = value.replace(/[^a-z0-9 ]/gi, "");
        document.getElementById("userTypeEdit").value = valueFinal;
        setUserTypeValue(valueFinal)
    }

    function handleAddNewUserType() {
        setUserTypeValue("")
        setFlag(false)
    }


    return (
        <>
         
            <main id="main" className="main">

                <div className="pagetitle page_title_box d-flex align-items-center justify-content-between">
                   <nav>
                        <h1>User Type</h1>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">User Management</li>
                            <li className="breadcrumb-item active">User Type</li>
                        </ol>
                    </nav>
                    <button type="button" className="btn btn-success" data-bs-toggle="modal" data-bs-target="#addNewUserType" onClick={() => handleAddNewUserType()}>Add New</button>
                </div>
                <section className="section">
                    <div className="row justify-content-lg-center">
                        <div className="col-lg-12 ">

                            <div className="card">

                                <MaterialReactTable
                                    columns={columns}
                                    data={usertypeData}
                                    enableColumnOrdering
                                    enablePagination={true}
                                />
                            </div>

                        </div>

                        <div className="col-lg-6">

                        </div>
                    </div>
                    <div className="modal" id="addNewUserType">
                        <div className="modal-dialog">
                            <div className="modal-content">

                                <div className="modal-header">
                                    <button type="button" className="btn-close" data-bs-dismiss="modal">X</button>
                                </div>

                                <div className="modal-body">
                                    <label for="add_season" className="form-label">Add New User Type</label>
                                    <input type="text" className="form-control" placeholder="Add New " onChange={e => handleUserTypeValue(e.target.value)} value={userTypeValue} maxLength={50}/>
                                </div>

                                <div className="modal-footer">
                                    <button type="button" className="btn btn-success"  onClick={AddNewUserType}>Add</button>
                                    <button type="button" className="btn btn-danger" data-bs-dismiss="modal">Close</button>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div id="mpopupBox" className="modal">

                        <div className="modal-content" >
                            <div className="modal-header">
                                <h2>View Details</h2>
                            </div>
                            <div className="madal-body" id="modal-content" >
                                <label for="edit_season" className="form-label">Edit UserType</label>
                                <input type="text" className="form-control" id="userTypeEdit" placeholder="" onChange={e => handleUserTypeValue(e.target.value)} maxLength={50}/>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-success" data-bs-dismiss="modal" onClick={EditUserType}>Add</button>
                                <button type="button" className="btn btn-danger" data-bs-dismiss="modal" onClick={removed}>Close</button>
                            </div>
                        </div>

                    </div>

                    <div className="modal" id="myDelete">
                        <div className="modal-dialog">
                            <div className="modal-content">

                                <div className="modal-header">
                                    <button type="button" className="btn-close" data-bs-dismiss="modal">X</button>
                                </div>

                                <div className="modal-body">
                                    <p>Are you sure you want to delete this item?</p>
                                </div>

                                <div className="modal-footer">
                                    <button type="button" className="btn btn-success" data-bs-dismiss="modal" onClick={deleteData}>Yes</button>
                                    <button type="button" className="btn btn-danger" data-bs-dismiss="modal">Close</button>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>

            </main>
           
        </>
    )
}

export default Usertype;

